import BaseInput from '../argonComponents/Inputs/BaseInput.vue';
import BaseDropdown from '../argonComponents/BaseDropdown.vue';
import Card from '../argonComponents/Cards/Card.vue';
import Modal from '../argonComponents/Modal.vue';
import StatsCard from '../argonComponents/Cards/StatsCard.vue';
import BaseButton from '../argonComponents/BaseButton.vue';
import Badge from '../argonComponents/Badge.vue';
//import RouteBreadcrumb from '../argonComponents/Breadcrumb/RouteBreadcrumb';
import BaseCheckbox from '../argonComponents/Inputs/BaseCheckbox.vue';
import BaseSwitch from '../argonComponents/BaseSwitch.vue';
import BaseRadio from '../argonComponents/Inputs/BaseRadio';
import BaseProgress from '../argonComponents/BaseProgress';
import BasePagination from '../argonComponents/BasePagination';
import BaseAlert from '../argonComponents/BaseAlert';
import BaseNav from '../argonComponents/Navbar/BaseNav';
import BaseHeader from '../argonComponents/BaseHeader';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { Input, Tooltip, Popover } from 'element-ui';

import Toast, { POSITION } from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";
//import "element-theme-chalk/lib/index.css";
//import "element-theme-chalk/lib/select.css";
import PostalCode from "japan-postal-code";



const options = {
  position: POSITION.BOTTOM_RIGHT,
  timeout:2000
    // You can set your default options here
};

/**
 * You can register global components here and use them as a plugin in your main Vue instance
 */

const GlobalComponents = {
  install(Vue) {
    Vue.component(Badge.name, Badge);
    Vue.component(BaseAlert.name, BaseAlert);
    Vue.component(BaseButton.name, BaseButton);
    Vue.component(BaseCheckbox.name, BaseCheckbox);
    Vue.component(BaseHeader.name, BaseHeader);
    Vue.component(BaseInput.name, BaseInput);
    Vue.component(BaseDropdown.name, BaseDropdown);
    Vue.component(BaseNav.name, BaseNav);
    Vue.component(BasePagination.name, BasePagination);
    Vue.component(BaseProgress.name, BaseProgress);
    Vue.component(BaseRadio.name, BaseRadio);
    Vue.component(BaseSwitch.name, BaseSwitch);
    Vue.component(Card.name, Card);
    Vue.component(Modal.name, Modal);
    Vue.component(StatsCard.name, StatsCard);
   // Vue.component(RouteBreadcrumb.name, RouteBreadcrumb);
    Vue.component(Input.name, Input);
    Vue.component('validation-provider', ValidationProvider);
    Vue.component('validation-observer', ValidationObserver);
    
    Vue.use(Tooltip);
    Vue.use(Popover);
    Vue.use(Toast, options);
    Vue.use(PostalCode);
    
  }
};

export default GlobalComponents;
